module.exports = __webpack_public_path__ + "static/media/AI_Review_color.4c6d25c5.png";